import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconsModule, LinkModule } from '@fcom/ui-components';
import { ComponentsModule } from '@fcom/common/components';
import { DirectiveModule } from '@fcom/common/directives';
import { PipesModule } from '@fcom/common/pipes/pipes.module';

import { OndMarketingOffersListComponent } from './components/ond-marketing-offers-list/ond-marketing-offers-list.component';
import { OndMarketingOffersComponent } from './components/ond-marketing-offers/ond-marketing-offers.component';
import { OndMarketingCrossLinkingComponent } from './components/ond-marketing-cross-linking/ond-marketing-cross-linking.component';
import { OndMarketingDisambiguationLinksComponent } from './components/ond-marketing-disambiguation-links/ond-marketing-disambiguation-links.component';

@NgModule({
  imports: [CommonModule, DirectiveModule, PipesModule, ComponentsModule, UiTranslateModule, IconsModule, LinkModule],
  declarations: [
    OndMarketingOffersListComponent,
    OndMarketingOffersComponent,
    OndMarketingCrossLinkingComponent,
    OndMarketingDisambiguationLinksComponent,
  ],
  exports: [
    OndMarketingOffersListComponent,
    OndMarketingOffersComponent,
    OndMarketingCrossLinkingComponent,
    OndMarketingDisambiguationLinksComponent,
  ],
})
export class OndMarketingLandingCoreModule {}
